import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
// import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
// import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    'CatalogService',
    '$uibModal',
    '$timeout'
];

class FeaturedSliderController {

    constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.productsInfo = {};
        this.featuredCategorys = {};
        this.imageData = [];

    }

    $onInit() {
      this.procedimientos=this.shCtrl.globalParams['slug-procedimientos'];
        if(this.itemData){
            angular.forEach(JSON.parse(this.itemData), (value, key) => {
                this.imageData.push({
                    img: value.imagesDetail.path + value.imagesDetail.image,
                    title: value.name,
                    globalRating: value.globalRating,
                    description: value.shortDescription,
                    link: value.slug
                });
            });

            if (this.imageData.length > 0 && !__env.adaptative) {
                this.initBrandsCarousel();
            }

        }else{
            this.getProcess();
        }
    }

    getProcess() {

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {}

        let type = 'destacados2';
        if(this.categoryId && this.itemId){
            type = 'relacionados_items_servicio';
        }

        let categoryId = this.categoryId || '';
        let itemId = this.itemId || '';

        this.CatalogService.getProducts(userId, 10, type,categoryId,itemId).then(response => {

            let val = this;
            angular.forEach(response, function (value, key) {
                val.imageData.push({
                    img: value.imagesDetail[0].path + value.imagesDetail[0].image,
                    title: value.name,
                    globalRating: value.globalRating,
                    description: value.shortDescription,
                    link: value.slug,
                    isNew: value.isNew,
                    isOffert: value.isOffert,
                    isOutstanding: value.isOutstanding,
                    isInternetExclusive: value.isInternetExclusive,
                    discountPercentage: value.discountPercentage

                });
            });

            if (this.imageData.length > 0 && !__env.adaptative) {
                this.initBrandsCarousel();
            }

        }).catch(error => {});
    }

    initBrandsCarousel() {
        var x = this.x;
        this.$timeout(function () {
            let brandsItemsSlider = $('.category-slider'+ x);
            brandsItemsSlider.owlCarousel({
                items: 4,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [979, 2],
                itemsTablet: [768, 2],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 8000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false,
                autoHeight: false
            }).data('navigationBtns', ["#carousel-category-slider-prev"+x, "#carousel-category-slider-next"+x]);
            brandsItemsSlider.each(function () {
                let $this = $(this),
                    owlCarousel = $this.data('owlCarousel'),
                    owlBtns = $this.data('navigationBtns'),
                    prevBtn, nextBtn;

                if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
                    return;
                }

                for (let key in owlBtns) {
                    if (owlBtns[key].indexOf('next') === -1) {
                        prevBtn = $(owlBtns[key]);
                    } else {
                        nextBtn = $(owlBtns[key]);
                    }
                }

                prevBtn.on('click touchstart', function (e) {
                    owlCarousel.prev();
                    e.preventDefault();
                });

                nextBtn.on('click touchstart', function (e) {
                    owlCarousel.next();
                    e.preventDefault();
                });
            });

            $('.add-tooltip').tooltip();
        }, 1000);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

}

FeaturedSliderController.$inject = inject;

export default FeaturedSliderController;




// WEBPACK FOOTER //
// ./www/components/home/featured-slider/featured-slider.controller.js